import { useCallback, useEffect, useMemo } from "react";
import { usePagination } from "../../../hooks/usePagination";
import { fetchRidersImport } from "../../../store/riders";
import { Navigation } from "../../../utils/navigation";
import styles from "./index.module.css";
import { renderColumns, renderStatusColumn, transformData, transformStatusTableData } from "./renderColumns";
import { BaseTable, Button, Loader, Pagination } from "../../../components";
import { redirectToPage } from "../../../utils/helpers";
import { bindActionCreators } from "redux";
import { connect } from 'react-redux';
import classNames from "classnames";
import { BackIcon } from "../../../assets";
import { URLS } from "../../../constants/constants";
import { exportReport } from "../../../store/reports";


export const RidersImport = ({
  importRiders,
  fetchRidersImport,
  exportReport,
  limit,
  currentPage,
  total,
  totalPages,
  syncCount,
  failedCount
}) => {
  const navigate = Navigation();
  const handleBack = () => {
    navigate.go(URLS.RIDERS);
  };

  usePagination(navigate);


  useEffect(() => {
    fetchRidersImport({ filtered: false, Navigation: navigate });

    return () => { };
  }, [fetchRidersImport]);

  const handleChangePage = (page) => {
    redirectToPage(navigate?.location?.pathname, page, navigate);
    fetchRidersImport({ Navigation: navigate });
  };

  const tableData = useMemo(() => {
    return transformData({
      data: importRiders,
      Navigation: navigate
    });
  }, [importRiders, navigate]);

  const columns = useMemo(() => {
    return renderColumns();
  }, [importRiders]);

  const RiderImportTable = useMemo(
    () => (
      <BaseTable
        data={tableData}
        columns={columns}
        addHoverEffectToRowTable
      />
    ),
    [tableData, columns]
  );

  const statusData = useMemo(() => {
    return transformStatusTableData({ importRiders, syncCount, failedCount });
  }, [importRiders]);

  const statusColumns = useMemo(() => {
    return renderStatusColumn();
  }, [importRiders]);

  const RiderStatusTable = useMemo(
    () => (
      <BaseTable
        data={statusData}
        columns={statusColumns}
      />
    ),
    [statusData, statusColumns]
  );

  return (
    <div className={styles.pageContent}>

      <div className={styles.header}>
        <div className={styles.pageTitle} onClick={handleBack}>
          <BackIcon width='18px' height='18px' fill='#BDBDBD' />
          <h1 className={styles.pageTitle}>Monitor your imports & syncs</h1>
        </div>
      </div>
      
      <div className={styles.tableStatusWrapper}>{RiderStatusTable}</div>

      <div className={classNames({
        [styles.addOrganization]: true,
      })}>
        <h1 className={styles.pageTitle}>Import Summary</h1>
        <Button
          myClassName={styles.addOrganizationBtn}
          onClick={() => { exportReport({ id: 'riders-upload-records' }) }}
        > Export
        </Button>
      </div>

      <div className={styles.tableWrapper}>{RiderImportTable}</div>
      <div
        className={classNames({
          [styles.pagination]: true,
          [styles.gapForPagination]: importRiders?.length > 4,
        })}
      >
        <Pagination
          defaultCurrent={currentPage}
          total={total}
          totalPages={totalPages}
          onChange={handleChangePage}
          pageSize={limit}
        />
      </div>
    </div>

  );
};

const mapStateToProps = (state) => (
  {
    importRiders: state.riders.importRiders,
    limit: state.riders.limit,
    currentPage: state.riders.currentPage,
    total: state.riders.total,
    totalPages: state.riders.totalPages,
    syncCount: state.riders.syncCount,
    failedCount: state.riders.failedCount
  });


const mapDispatchToProps = (dispatch) =>
  bindActionCreators({ fetchRidersImport, exportReport }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(RidersImport);